import moment from "moment";

export const findValue = (obj: any, targetKey: string): any => {
  if (!obj) return undefined;

  const normalize = (s: string) => s.toLowerCase().replace(/_/g, "");
  const targetNormalized = normalize(targetKey);

  const lookup = (currentObj: any): any => {
    if (!currentObj || typeof currentObj !== "object") return undefined;
    const keys = Object.keys(currentObj);
    const foundKey = keys.find((k) => normalize(k) === targetNormalized);
    if (foundKey !== undefined && currentObj[foundKey] !== null) {
      return currentObj[foundKey];
    }
    return undefined;
  };

  // 1. Top level check
  let val = lookup(obj);
  if (val !== undefined) return val;

  // 2. Check in .data or .attributes
  val = lookup(obj.data);
  if (val !== undefined) return val;

  val = lookup(obj.attributes);
  if (val !== undefined) return val;

  return undefined;
};

export const transformV2Record = (record: any, registerValue: string) => {
  // 1. Resolve Timestamp
  const tsVal =
    findValue(record, "readingTime") ??
    findValue(record, "receivedDate") ??
    findValue(record, "ts") ??
    findValue(record, "dateTime") ??
    findValue(record, "timestamp");

  const ts = (tsVal !== null && tsVal !== undefined) ? moment(tsVal).valueOf() : NaN;

  // 2. Resolve Key (CamelCase from IP_ prefixed or raw)
  const mappingKey = registerValue.startsWith("IP_")
    ? registerValue.replace("IP_", "").charAt(0).toLowerCase() +
      registerValue.replace("IP_", "").slice(1)
    : registerValue;

  // 3. Aggressive Value Resolve
  let val = findValue(record, mappingKey);

  // Fallbacks if not found by primary key
  if (val === undefined || val === null) {
    if (mappingKey === "kW" || mappingKey === "activePowerW") {
      val =
        findValue(record, "activePowerW") ??
        findValue(record, "kW") ??
        findValue(record, "activePower");
    } else if (mappingKey === "kVA" || mappingKey === "apparentPowerVa") {
      val =
        findValue(record, "apparentPowerVa") ??
        findValue(record, "kVA") ??
        findValue(record, "apparentPower");
    } else if (
      mappingKey === "kWh" ||
      mappingKey === "cumulativeEnergyKwhImport" ||
      mappingKey === "blockEnergyKwhImport"
    ) {
      val =
        findValue(record, "cumulativeEnergyKwhImport") ??
        findValue(record, "blockEnergyKwhImport") ??
        findValue(record, "kWh") ??
        findValue(record, "energy");
    }
  }

  // Final fallback to raw registerValue
  if (val === undefined || val === null) {
    val = findValue(record, registerValue);
  }

  return {
    ts: isNaN(ts) ? 0 : ts,
    readingTime: tsVal ?? "",
    val: val !== null && val !== undefined ? val : undefined,
    mappingKey
  };
};
